import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from 'components/ErrorFallBack/ErrorFallback';

const logger = (error) => console.error('error', error);

const ErrorProvider = ({ children }) => (
  <ErrorBoundary FallbackComponent={ErrorFallback} onError={logger}>
    {children}
  </ErrorBoundary>
);

export default ErrorProvider;
